<template>
    <div class="rounded-lg">
        <label class="typo__label h2--background mr-3 d-none">Standort:</label>
        <multiselect
            ref="merchantSelect"
            v-model="contactValue"
            :allow-empty="false"
            :disabled="isDisabled"
            :group-select="false"
            :multiple="false"
            :options="this.wholesalerMerchantData"
            :preselect-first="true"
            :searchable="true"
            class="rounded-0"
            deselect-label="Dieser Wert kann nicht entfernt werden."
            group-label="wholesaler"
            group-values="merchants"
            label="name"
            placeholder="Standort auswählen ..."
            track-by="name"
            @close="updateSelectedMerchant"
        ></multiselect>
    </div>
</template>

<script>
export default {
    name: 'SignupMerchant',
    props: {
        contactType: null,
        contactId: null,
        wholesalerMerchantData: null,
        isDisabled: null,
    },
    data: function() {
        return {
            contactValue: null,
            options: [],
        };
    },

    created() {
        this.contactValue = this.wholesalerMerchantData[0]['merchants'][0];
        this.updateSelectedMerchant();
    },

    methods: {
        updateSelectedMerchant: function() {
            this.$emit('emitUpdateSelectedMerchant', this.contactValue);
        },
    },
};

</script>

<style scoped>

</style>
